export default __webpack_public_path__ + "/dist/images/banner.124f9f716d36a9785046dd8a5290d712.jpg";